import type { UseDisclosureReturn } from '@tyro/core/hooks';
import { createContext, useContext } from 'react';
import type { MailComposeProps } from '../@types/compose-mail';
import type { MailLabel } from '../@types/label';
import type {
  MailRecipientType,
  RecipientsForMailModal,
} from '../components/common/select-mail-recipient-type-modal';

export type MailSettingsContextValue = {
  sidebarDisclosure: UseDisclosureReturn;
  composeDisclosure: UseDisclosureReturn;
  openAdvancedSearch: () => void;
  activeProfileId: number;
  composeEmail: (defaultValue: MailComposeProps['defaultValues']) => void;
  sendMailToParties: (
    parties: RecipientsForMailModal,
    possibleMailRecipientTypes: MailRecipientType[],
  ) => void;
  hasPermissionForSchoolInbox: boolean;
  hasPermissionForRulesInbox: boolean;
  isSchoolMail: boolean;
  isRulesMail: boolean;
  isScheduledMailList: boolean;
  partyUnreadCount: number;
  schoolUnreadCount: number;
  rulesUnreadCount: number;
  getUnreadCount: (label: Pick<MailLabel, 'type' | 'id'>) => number;
};

export const MailSettingsContext = createContext<
  MailSettingsContextValue | undefined
>(undefined);

export function useMailSettings() {
  const context = useContext(MailSettingsContext);
  if (context === undefined) {
    throw new Error(
      'useMailSettings must be used within a MailSettingsContext',
    );
  }
  return context;
}
